/**
 * NIP-54 `d` tag normalization.
 *
 * Rules (from NIP-54):
 * - Lowercase all letters with case variants.
 * - Whitespace -> `-`.
 * - Punctuation/symbols removed.
 * - Multiple consecutive `-` collapsed to one.
 * - Leading/trailing `-` removed.
 * - Non-ASCII letters (CJK, Cyrillic, etc.) preserved.
 * - Numbers preserved.
 */
export function normalizeWikiTitle(input: string): string {
  return input
    .trim()
    .toLowerCase()
    // Remove ASCII punctuation/symbols, but keep letters (incl. non-ASCII),
    // numbers, whitespace, and hyphens/underscores.
    .replace(/[!"#$%&'()*+,./:;<=>?@[\]\\^`{|}~]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/** Turns a slug like `nostr-protocol` into a display fallback `Nostr Protocol`. */
export function prettifySlug(slug: string): string {
  return slug
    .split('-')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
